module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', {
    attrs: {
      "id": "an-zhuang"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#an-zhuang",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 安装")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "ynpm-an-zhuang"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#ynpm-an-zhuang",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" ynpm安装")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "hljs"
  }, [_vm._v("npm i @youzan/zanui-vue -S\n")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-901d4a30!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/install-5.vue
// module id = 305
// module chunks = 0